import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { Container, FormContainer } from "./LoginStyles";
// import logo from "../../../assets/images/headerLogo.svg";
// import btnlogo from "../../../assets/images/btnLogo.svg";
import { login } from "../../../redux/slices/authSlice";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const toggleType = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <Container>
      <FormContainer>
      <h2>Meta<span>Click</span></h2>
        <h1>Sign In</h1>
        <form onSubmit={handleSubmit}>
          <div className="single-form">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="single-form">
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {showPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType} />
            ) : (
              <FaEye className="eye" onClick={toggleType} />
            )}
          </div>
          <div className="forgot-password">
            <p></p>
            <a href="/forgot-password">Forgot password</a>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
        {/* <p>
          Don’t have an account? <a href="/signup">Sign up</a>
        </p> */}
      </FormContainer>

      {/* <ImgSection>
        <div>
          <img src={btnlogo} alt="" />
          <p>
            Run your ads and campaigns with DIgiCick and make huge <br />
            impressions and conversions that will help yout business{" "}
          </p>
        </div>
      </ImgSection> */}
    </Container>
  );
};

export default Login;
